import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_SmoothResize = _resolveComponent("SmoothResize")

  return (_openBlock(), _createBlock(_component_SmoothResize, {
    class: "send-button",
    active: $props.generating ? 'stop' : 'send'
  }, {
    stop: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "stop-button",
        primary: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('stop')), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            icon: "stop",
            width: "1.6rem",
            height: "1.6rem"
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    send: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "input-button",
        disabled: !$props.canPush,
        primary: "",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('push', $event)), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            class: "send-icon",
            icon: "arrow-up",
            stroke: "var(--base-white)",
            width: "1.6rem",
            height: "1.6rem"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["active"]))
}